import { useEffect, useState } from 'react';

import { SingleAssignment } from 'shared/api/assignment-service';
import {
  getTwoArraysIntersection,
  useDigitalExperienceAssetsBks,
} from 'shared/lib/utils';

import {
  WALKTHROUGH_ALL_ASSIGNMENTS_BY_PRODUCT_MAP,
  WALKTHROUGH_PRODUCTS_IDS_MAP,
} from '../constants';

export const useWalkthroughAssignments = () => {
  const [walkthroughAssignments, setWalkthroughAssignments] =
    useState<SingleAssignment[]>();

  const digitalExperienceAssetsBks = useDigitalExperienceAssetsBks();

  useEffect(() => {
    if (!digitalExperienceAssetsBks) return;

    const relevantAssignments: SingleAssignment[] = [];

    Object.entries(WALKTHROUGH_PRODUCTS_IDS_MAP).forEach(
      ([productName, productAssetsIds]) => {
        const foundAssets = getTwoArraysIntersection(
          digitalExperienceAssetsBks,
          productAssetsIds,
        );

        if (foundAssets.length) {
          relevantAssignments.push(
            WALKTHROUGH_ALL_ASSIGNMENTS_BY_PRODUCT_MAP[productName],
          );
        }
      },
    );

    setWalkthroughAssignments(relevantAssignments);
  }, [digitalExperienceAssetsBks]);

  return {
    walkthroughAssignments,
  };
};
